<template>
    <v-card elevation="4" class="ma-2 zoezi-list-card course-category overflow-hidden" :class="{'full-width' : titleRight}" @click="$emit('click')" :to="to">
        <v-auto-img :src="image" class="card-image" v-if="!titleRight" :ar="3/2">
            <div class="primary card-title" :style="background">
                <div class="primarytext--text">{{category.name}}</div>
            </div>
        </v-auto-img>
        <div v-else class="d-flex align-center">
            <v-auto-img :src="image" class="card-image-blur" :ar="3/2" />
            <v-auto-img :src="image" class="z-half inherit-border-left" :ar="3/2" />
            <div class="z-half inherit-border-right pa-4 fill-height">
                <div class="primary--text">
                    <div class="card-title" :class="{'text-center text-large' : !category.description}">{{category.name}}</div>
                    <div v-html="category.description" class="description black--text" />
                </div>
            </div>
        </div>
    </v-card>
</template>

<script>
export default {
    name: 'zoezi-category-card',

    zoezi: {
        title: 'Kategori',
        icon: 'mdi-format-list-text'
    },

    props: {
        category: {
            type: Object
        },
        titleRight: {
            type: Boolean
        },
        defaultImageKey: {
            type: String,
        },
        to: {
            type: String
        }
    },
    computed: {
        image() {
            return this.category.imagekey || this.defaultImageKey;
        },
        background() {
            return {'background-color': this.$root.colorToHex('primary') + 'b4 !important'};
        }
    }
}
</script>
